import React, { useState, useRef } from "react";
import Modal from "../../components/common/Modal";

/* ── Seed data ── */
const STUDENTS = [
  {
    id: 1, name: "P. Nishanth Shankar", admNo: "252601",
    class: "1ST CLASS", section: "A", guardian: "P. Shiva Shankar",
    mobile: "8008053730", photo: "",
    hallTicket: "5574",
    subjects: [
      { name: "ENGLISH",                date: "2025-07-23", time: "11 AM TO 11:45 AM" },
      { name: "MATHS",                  date: "2025-07-24", time: "11 AM TO 11:45 AM" },
      { name: "EVS",                    date: "2025-07-25", time: "11 AM TO 11:45 AM" },
      { name: "RHYMES & STORY TELLING", date: "2025-07-28", time: "11 AM TO 11:45 AM" },
      { name: "ART & CRAFT \\ ORAL",    date: "2025-07-29", time: "11 AM TO 11:45 AM" },
    ],
  },
  {
    id: 2, name: "M. Chokshith", admNo: "252602",
    class: "1ST CLASS", section: "A", guardian: "M. Prashanth",
    mobile: "9949528696", photo: "https://via.placeholder.com/90",
    hallTicket: "5575",
    subjects: [
      { name: "ENGLISH",                date: "2025-07-23", time: "11 AM TO 11:45 AM" },
      { name: "MATHS",                  date: "2025-07-24", time: "11 AM TO 11:45 AM" },
      { name: "EVS",                    date: "2025-07-25", time: "11 AM TO 11:45 AM" },
      { name: "RHYMES & STORY TELLING", date: "2025-07-28", time: "11 AM TO 11:45 AM" },
      { name: "ART & CRAFT \\ ORAL",    date: "2025-07-29", time: "11 AM TO 11:45 AM" },
      { name: "HINDI",                  date: "2025-07-30", time: "11 AM TO 11:45 AM" },
      { name: "TELUGU",                 date: "2025-07-31", time: "11 AM TO 11:45 AM" },
    ],
  },
  {
    id: 3, name: "S. Mahanth", admNo: "252603",
    class: "1ST CLASS", section: "A", guardian: "S. Ramu",
    mobile: "9908727059", photo: "",
    hallTicket: "5576",
    subjects: [
      { name: "ENGLISH",                date: "2025-07-23", time: "11 AM TO 11:45 AM" },
      { name: "MATHS",                  date: "2025-07-24", time: "11 AM TO 11:45 AM" },
      { name: "EVS",                    date: "2025-07-25", time: "11 AM TO 11:45 AM" },
      { name: "RHYMES & STORY TELLING", date: "2025-07-28", time: "11 AM TO 11:45 AM" },
      { name: "ART & CRAFT \\ ORAL",    date: "2025-07-29", time: "11 AM TO 11:45 AM" },
    ],
  },
];

const HISTORY_ROWS = [
  { srNo: 1, studentName: "P. Shiva Shankar", hallTicketNo: "5574", studentId: 1, className: "1ST CLASS", section: "A", examName: "FORMATIVE ASSESSMENT -1", createdTime: "2025-07-25 11:37:05" },
  { srNo: 2, studentName: "M. Prashanth", hallTicketNo: "5575", studentId: 2, className: "1ST CLASS", section: "A", examName: "FORMATIVE ASSESSMENT -1", createdTime: "2025-07-25 11:38:10" },
  { srNo: 3, studentName: "S. Ramu", hallTicketNo: "5576", studentId: 3, className: "PP-1",      section: "A", examName: "SUMMATIVE ASSESSMENT-1",  createdTime: "2025-07-26 09:05:31" },
];

/* ── Initials avatar (when no photo) ── */
function Avatar({ name, size = 80 }) {
  const parts    = name.trim().split(/\s+/);
  const initials = parts.length >= 2
    ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    : parts[0].slice(0, 2).toUpperCase();

  const colors = ["#1565c0","#6a1b9a","#2e7d32","#e65100","#c62828","#00695c"];
  const bg     = colors[name.charCodeAt(0) % colors.length];

  return (
    <div style={{
      width: size, height: size, borderRadius: 4,
      background: bg, color: "#fff",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: size * 0.3, fontWeight: 700, letterSpacing: 1,
      border: "1px solid #ccc", flexShrink: 0,
    }}>
      {initials}
    </div>
  );
}

/* ── CSS for print: 2 hall tickets per A4 page ── */
const PRINT_STYLES = `
  @media print {
    @page { size: A4 portrait; margin: 8mm; }
    body  { margin: 0; }
    .ht-wrapper { display: flex; flex-direction: column; gap: 0; }
    .ht-page-pair { display: flex; flex-direction: column; page-break-after: always; }
    .ht-ticket   { flex: 1; box-sizing: border-box; margin-bottom: 6mm; }
    .ht-ticket:last-child { margin-bottom: 0; }
    .no-print { display: none !important; }
  }
  @media screen {
    .ht-page-pair { display: flex; flex-direction: column; gap: 20px; margin-bottom: 32px; }
    .ht-ticket { border: 2px solid #333; background: #fff; }
  }
`;

/* ── Single Hall Ticket ── */
function HallTicket({ student, examName, format }) {
  const isModern = format.includes("2");
  const accent   = isModern ? "#1a237e" : "#000";
  const headerBg = isModern ? "#1a237e" : "#fff";
  const headerFg = isModern ? "#fff"    : "#000";
  const subHdrFg = isModern ? "#ccc"    : "#555";

  const cell = { padding: "6px 10px", borderRight: "1px solid #ccc", fontSize: 12, verticalAlign: "middle" };
  const hdr  = { ...cell, fontWeight: 700, background: "#f5f5f5", fontSize: 11, borderBottom: "1px solid #ccc" };

  return (
    <div className="ht-ticket" style={{ fontFamily: "Arial, sans-serif", fontSize: 12 }}>

      {/* ── Header ── */}
      <table style={{ width: "100%", borderCollapse: "collapse", background: headerBg, color: headerFg, borderBottom: "2px solid #333" }}>
        <tbody>
          <tr>
            {/* Logo */}
            <td style={{ width: 100, padding: 8, borderRight: "1px solid #ccc", textAlign: "center", verticalAlign: "middle" }}>
              <div style={{
                width: 72, height: 72, borderRadius: "50%",
                background: isModern ? "#fff" : "#e8f5e9",
                display: "flex", alignItems: "center", justifyContent: "center",
                margin: "0 auto", border: "2px solid #4caf50",
              }}>
                <span style={{ fontSize: 9, fontWeight: 700, color: "#2e7d32", textAlign: "center", lineHeight: 1.3 }}>
                  SRINI<br/>PLAY<br/>SCHOOL
                </span>
              </div>
            </td>

            {/* School name */}
            <td style={{ textAlign: "center", padding: "8px 16px", verticalAlign: "middle" }}>
              <div style={{ fontSize: 17, fontWeight: 700, letterSpacing: 0.5, color: isModern ? "#fff" : accent }}>
                SRINI THE PLAY SCHOOL &amp; ACADEMY
              </div>
              <div style={{ fontSize: 10, color: subHdrFg, marginTop: 2 }}>
                Near GHMC Ground, Shamlal Building, Begumpet, Hyderabad
              </div>
              <div style={{ fontSize: 12, fontWeight: 700, marginTop: 5, color: isModern ? "#90caf9" : accent }}>
                HALL TICKET &nbsp;|&nbsp; EXAMINATION SCHEDULE
              </div>
            </td>

            {/* Photo / initials */}
            <td style={{ width: 108, padding: 8, borderLeft: "1px solid #ccc", textAlign: "center", verticalAlign: "middle" }}>
              {student.photo
                ? <img src={student.photo} alt={student.name}
                    style={{ width: 72, height: 72, objectFit: "cover", border: "1px solid #ccc", display: "block", margin: "0 auto" }} />
                : <Avatar name={student.name} size={72} />
              }
              <div style={{ fontSize: 10, fontWeight: 600, marginTop: 4, color: headerFg, lineHeight: 1.3 }}>{student.name}</div>
              <div style={{ fontSize: 9, color: subHdrFg }}>D/S/O {student.guardian}</div>
            </td>
          </tr>
        </tbody>
      </table>

      {/* ── Hall Ticket No + Exam row ── */}
      <table style={{ width: "100%", borderCollapse: "collapse", borderBottom: "1px solid #333" }}>
        <tbody>
          <tr>
            <td style={{ width: 170, padding: "6px 10px", borderRight: "1px solid #333", fontWeight: 700, fontSize: 11, verticalAlign: "middle" }}>
              HALL TICKET NO :&nbsp;
              <span style={{ color: accent }}>{student.hallTicket || "___________"}</span>
            </td>
            <td style={{ textAlign: "center", padding: "5px 0", verticalAlign: "middle" }}>
              <div style={{ fontWeight: 700, fontSize: 14, letterSpacing: 0.3 }}>{examName}</div>
              <div style={{ fontSize: 11, color: "#555", marginTop: 2 }}>
                {student.class} - {student.section}&nbsp;&nbsp;|&nbsp;&nbsp;Adm No: {student.admNo}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {/* ── Subject schedule ── */}
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ ...hdr, width: 44, textAlign: "center" }}>S.No</th>
            <th style={hdr}>Subject</th>
            <th style={{ ...hdr, width: 190, textAlign: "center" }}>Date &amp; Time</th>
            <th style={{ ...hdr, width: 140, textAlign: "center" }}>Invigilator Sign</th>
          </tr>
        </thead>
        <tbody>
          {student.subjects.map((subj, i) => (
            <tr key={i} style={{ borderBottom: "1px solid #ddd" }}>
              <td style={{ ...cell, textAlign: "center", fontWeight: 700 }}>{i + 1}</td>
              <td style={cell}>{subj.name}</td>
              <td style={{ ...cell, textAlign: "center" }}>
                <div style={{ fontWeight: 600 }}>{subj.date}</div>
                <div style={{ fontSize: 10, color: "#555" }}>{subj.time}</div>
              </td>
              <td style={cell}></td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ── Signature footer ── */}
      <table style={{ width: "100%", borderCollapse: "collapse", borderTop: "2px solid #333" }}>
        <tbody>
          <tr>
            {[
              { label: "Class Teacher Signature", content: null },
              { label: "Student Signature",       content: <div style={{ fontSize: 11, color: "#555", marginBottom: 2 }}>{student.name}</div> },
              { label: "Principal Signature",     content: null },
            ].map((col, i) => (
              <td key={i} style={{
                padding: "8px 16px", textAlign: "center", verticalAlign: "bottom",
                borderRight: i < 2 ? "1px solid #ccc" : "none", fontSize: 11,
              }}>
                {col.content}
                <div style={{ marginTop: 22, borderTop: "1px solid #333", paddingTop: 3 }}>{col.label}</div>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}

/* ── Printable area: 2 tickets per A4 page ── */
function PrintArea({ students, examName, format, forwardedRef }) {
  // Chunk into pairs
  const pairs = [];
  for (let i = 0; i < students.length; i += 2)
    pairs.push(students.slice(i, i + 2));

  return (
    <div ref={forwardedRef} className="ht-wrapper">
      <style>{PRINT_STYLES}</style>
      {pairs.map((pair, pi) => (
        <div key={pi} className="ht-page-pair">
          {pair.map(student => (
            <div key={student.id} className="ht-ticket">
              <HallTicket student={student} examName={examName} format={format} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

/* ══════════════════════════════
   MAIN COMPONENT
══════════════════════════════ */
const GenerateHallTickets = () => {
  const printRef = useRef(null);

  const [formData, setFormData] = useState({
    academicYear: "", curriculum: "", exam: "", className: "", section: "",
  });

  const [students, setStudents]       = useState(STUDENTS);
  const [selected, setSelected]       = useState([]);
  const [hallTicket, setHallTicket]   = useState(false);
  const [showModal, setShowModal]     = useState(false);
  const [showModal2, setShowModal2]   = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const [showSubjects, setShowSubjects] = useState("No");
  const [format, setFormat]             = useState("Format 3 - Compact Elegant");

  // Which student to print from history link click
  const [historyPrintStudent, setHistoryPrintStudent] = useState(null);
  const [showHistoryPrint, setShowHistoryPrint]       = useState(false);
  const historyPrintRef = useRef(null);

  /* ── Select all / individual ── */
  const allSelected = students.length > 0 && selected.length === students.length;
  const toggleAll   = () => setSelected(allSelected ? [] : students.map(s => s.id));
  const toggleOne   = id  => setSelected(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);

  const handleTicketChange = (id, value) =>
    setStudents(prev => prev.map(s => s.id === id ? { ...s, hallTicket: value } : s));

  const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleSearch = () => setHallTicket(true);
  const handleReset  = () => { setFormData({ academicYear: "", curriculum: "", exam: "", className: "", section: "" }); setHallTicket(false); setSelected([]); };

  const examLabel = formData.exam || "FORMATIVE ASSESSMENT -1";

  /* ── Generate: only selected students, guard if none ── */
  const handleGenerate = () => {
    if (selected.length === 0) {
      alert("Please select at least one student using the checkboxes before generating.");
      return;
    }
    setShowModal2(false);
    setTimeout(() => setShowPreview(true), 200);
  };

  /* ── Print helper ── */
  const doPrint = (ref) => {
    const content = ref.current?.innerHTML;
    if (!content) return;
    const win = window.open("", "_blank");
    win.document.write(`<!DOCTYPE html><html><head><title>Hall Tickets</title>
      <style>
        body { margin: 0; font-family: Arial, sans-serif; }
        table { border-collapse: collapse; }
        ${PRINT_STYLES}
      </style>
    </head><body>${content}</body></html>`);
    win.document.close();
    setTimeout(() => { win.focus(); win.print(); win.close(); }, 500);
  };

  /* ── History ticket link: find student and show single ticket print ── */
  const handleHistoryLink = (row) => {
    const student = students.find(s => s.id === row.studentId) || {
      id: row.srNo, name: "Unknown Student", admNo: row.hallTicketNo,
      class: row.className, section: row.section, guardian: "-",
      mobile: "-", photo: "", hallTicket: row.hallTicketNo,
      subjects: [{ name: "ENGLISH", date: "-", time: "-" }],
    };
    setHistoryPrintStudent(student);
    setShowModal(false);
    setTimeout(() => setShowHistoryPrint(true), 200);
  };

  const selectedStudents = students.filter(s => selected.includes(s.id));

  return (
    <div>
      <style>{`
        .btn-add { background:#16c3c8; color:#fff; border:none; border-radius:4px; padding:6px 14px; font-size:13px; cursor:pointer; font-weight:500; }
        .btn-add:hover { background:#13adb2; }
        .ht-card .card-header { display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:8px; }
      `}</style>

      {/* ── Filter card ── */}
      <div className="card border-0 shadow-sm">
        <div className="card-header bg-white" style={{ borderBottom: "2px solid #16c3c8" }}>
          <h5 className="mb-0 fw-normal">Generate Hall Tickets</h5>
        </div>
        <div className="card-body p-3">
          <div className="row g-3 align-items-end">
            <div className="col-md-2 col-sm-4">
              <label className="form-label small">Academic Year</label>
              <select className="form-select" name="academicYear" value={formData.academicYear} onChange={handleChange}>
                <option value="">2026-27</option>
                <option value="2025-26">2025-26</option>
              </select>
            </div>
            <div className="col-md-2 col-sm-4">
              <label className="form-label small">Curriculum</label>
              <select className="form-select" name="curriculum" value={formData.curriculum} onChange={handleChange}>
                <option value="">Select Curriculum</option>
                <option value="ssc">SSC</option>
                <option value="cbse">CBSE</option>
                <option value="icse">ICSE</option>
              </select>
            </div>
            <div className="col-md-2 col-sm-4">
              <label className="form-label small">Select Exam <span className="text-danger">*</span></label>
              <select className="form-select" name="exam" value={formData.exam} onChange={handleChange}>
                <option value="">-- Select Exam --</option>
                <option value="FORMATIVE ASSESSMENT -1">FORMATIVE ASSESSMENT -1</option>
                <option value="SUMMATIVE ASSESSMENT-1">SUMMATIVE ASSESSMENT-1</option>
                <option value="First Term">First Term</option>
                <option value="Final Exam">Final Exam</option>
              </select>
            </div>
            <div className="col-md-2 col-sm-4">
              <label className="form-label small">Class Name</label>
              <select className="form-select" name="className" value={formData.className} onChange={handleChange}>
                <option value="">Select Class</option>
                <option value="NURSERY">NURSERY</option>
                <option value="PP-1">PP-1</option>
                <option value="1ST CLASS">1ST CLASS</option>
              </select>
            </div>
            <div className="col-md-2 col-sm-4">
              <label className="form-label small">Section Name</label>
              <select className="form-select" name="section" value={formData.section} onChange={handleChange}>
                <option value="">Select Section</option>
                <option value="A">A</option>
                <option value="B">B</option>
              </select>
            </div>
            <div className="col-md-2 col-sm-4">
              <div className="d-flex gap-2">
                <button className="btn-add px-3" onClick={handleSearch}>🔍 Search</button>
                <button className="btn btn-outline-secondary btn-sm" onClick={handleReset}>Reset</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Results ── */}
      {hallTicket && (
        <>
          <div className="card mt-3 ht-card">
            <div className="card-header bg-white py-2">
              <h5 className="mb-0 fw-normal" style={{ fontSize: 15 }}>List Of Generate Hall Tickets</h5>
              <div className="d-flex gap-2 flex-wrap">
                <button className="btn-add" onClick={() => setShowModal(true)}>📋 Hall Tickets History</button>
                <button className="btn-add" onClick={() => setShowModal2(true)}>🎫 Generate Hall Tickets</button>
              </div>
            </div>

            <div className="card-body p-0">
              {selected.length > 0 && (
                <div className="px-3 py-2 border-bottom d-flex align-items-center gap-2" style={{ background: "#e8f4fd", fontSize: 13 }}>
                  <span className="text-primary fw-semibold">{selected.length}</span> of {students.length} student(s) selected.
                  <button className="btn btn-link btn-sm p-0 ms-1" onClick={() => setSelected([])}>Clear</button>
                </div>
              )}

              <div className="table-responsive">
                <table className="table table-hover border align-middle mb-0">
                  <thead className="table-light">
                    <tr className="text-secondary small">
                      <th className="px-3">Sr.No</th>
                      <th>Student Name</th>
                      <th>Class-Section</th>
                      <th>Guardian Name</th>
                      <th>Mobile</th>
                      <th>Photo</th>
                      <th>Hall Ticket No</th>
                      <th className="text-center px-3">
                        <div className="d-flex align-items-center gap-1 justify-content-center">
                          <input type="checkbox" className="form-check-input mt-0"
                            checked={allSelected} onChange={toggleAll} title="Select All" />
                          <span style={{ fontSize: 11 }}>All</span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {students.map((student, index) => (
                      <tr key={student.id} style={{ background: selected.includes(student.id) ? "#f0f9ff" : "" }}>
                        <td className="px-3">{index + 1}</td>
                        <td style={{ fontWeight: 500 }}>
                          <div className="d-flex align-items-center gap-2">
                            {student.photo
                              ? <img src={student.photo} alt="" width={32} height={32}
                                  style={{ borderRadius: 4, objectFit: "cover", border: "1px solid #dee2e6" }} />
                              : <Avatar name={student.name} size={32} />
                            }
                            {student.name}
                          </div>
                        </td>
                        <td>{student.class} - {student.section}</td>
                        <td>{student.guardian}</td>
                        <td>{student.mobile}</td>
                        <td>
                          {student.photo
                            ? <img src={student.photo} alt="" width={48} height={48}
                                style={{ objectFit: "cover", borderRadius: 4, border: "1px solid #dee2e6" }} />
                            : <Avatar name={student.name} size={48} />
                          }
                        </td>
                        <td>
                          <input type="text" className="form-control form-control-sm"
                            value={student.hallTicket} placeholder="Enter ticket no."
                            onChange={e => handleTicketChange(student.id, e.target.value)}
                            style={{ width: 150 }} />
                        </td>
                        <td className="text-center px-3">
                          <input type="checkbox" className="form-check-input mt-0"
                            checked={selected.includes(student.id)}
                            onChange={() => toggleOne(student.id)} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* ── History Modal ── */}
         {/* ── History Modal ── */}
<Modal show={showModal} onClose={() => setShowModal(false)} title="Hall Ticket History" size="xl">
  <div className="table-responsive">
    <table className="table table-bordered table-hover mb-0">
      <thead className="table-light">
        <tr>
          <th>Sr.No</th>
          <th>Hall Ticket No</th>
          <th>Student Name</th>
          <th>Class Name</th>
          <th>Section</th>
          <th>Exam Name</th>
          <th>Created Time</th>
        </tr>
      </thead>
      <tbody>
        {HISTORY_ROWS.map(row => {
          const student = students.find(s => s.id === row.studentId);
          return (
            <tr key={row.srNo}>
              <td>{row.srNo}</td>
              <td>
                <button
                  onClick={() => handleHistoryLink(row)}
                  style={{ background: "none", border: "none", color: "#0d6efd", cursor: "pointer", textDecoration: "underline", padding: 0, fontSize: 13 }}
                >
                  {row.hallTicketNo}
                </button>
              </td>
              <td>
                <div className="d-flex align-items-center gap-2">
                  {student ? (
                    student.photo
                      ? <img src={student.photo} alt="" width={28} height={28}
                          style={{ borderRadius: 4, objectFit: "cover", border: "1px solid #dee2e6", flexShrink: 0 }} />
                      : <Avatar name={student.name} size={28} />
                  ) : null}
                  <span>{student ? student.name : "—"}</span>
                </div>
              </td>
              <td>{row.className}</td>
              <td>{row.section}</td>
              <td>{row.examName}</td>
              <td>{row.createdTime}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
</Modal>

          {/* ── Generate Options Modal ── */}
          <Modal show={showModal2} onClose={() => setShowModal2(false)} title="Generate Hall Tickets" size="md">
            <div className="p-2">
              <h6 className="fw-semibold mb-3">Select Instructions</h6>
              <hr className="my-3" />
              <div className="mb-3">
                <label className="form-label fw-semibold small">Show Other Subjects in Hall Ticket</label>
                <div className="d-flex gap-4 mt-2">
                  {["Yes", "No"].map(val => (
                    <div key={val} className="form-check">
                      <input className="form-check-input" type="radio" name="subjects"
                        value={val} checked={showSubjects === val}
                        onChange={e => setShowSubjects(e.target.value)} />
                      <label className="form-check-label">{val}</label>
                    </div>
                  ))}
                </div>
              </div>
              <hr className="my-3" />
              <div className="mb-4">
                <label className="form-label fw-semibold small">Hall Ticket Format</label>
                <select className="form-select" value={format} onChange={e => setFormat(e.target.value)}>
                  <option value="Format 1 - Simple">Format 1 - Simple</option>
                  <option value="Format 2 - Modern">Format 2 - Modern</option>
                  <option value="Format 3 - Compact Elegant">Format 3 - Compact Elegant</option>
                </select>
              </div>

              {/* Guard message */}
              {selected.length === 0
                ? <div className="alert alert-warning py-2 small mb-3">
                    ⚠ No students selected. Please tick the checkboxes in the list before generating.
                  </div>
                : <div className="alert alert-success py-2 small mb-3">
                    ✅ Generating hall tickets for <strong>{selected.length}</strong> selected student(s).
                  </div>
              }
            </div>
            <div className="d-flex justify-content-end gap-2 border-top pt-3">
              <button className="btn btn-light px-4" onClick={() => setShowModal2(false)}>Cancel</button>
              <button className="btn btn-success px-4" onClick={handleGenerate}
                disabled={selected.length === 0}>
                🎫 Generate Hall Tickets
              </button>
            </div>
          </Modal>

          {/* ── Print Preview Modal (selected students, 2 per A4) ── */}
          <Modal show={showPreview} onClose={() => setShowPreview(false)} title={`Hall Ticket Preview — ${selectedStudents.length} Student(s)`} size="xl">
            <div className="d-flex justify-content-end gap-2 mb-3 no-print">
              <button className="btn btn-outline-secondary btn-sm" onClick={() => setShowPreview(false)}>Close</button>
              <button className="btn btn-primary btn-sm px-4" onClick={() => doPrint(printRef)}>
                🖨 Print / Download PDF
              </button>
            </div>
            <PrintArea
              students={selectedStudents}
              examName={examLabel}
              format={format}
              forwardedRef={printRef}
            />
          </Modal>

          {/* ── History Single Ticket Print Modal ── */}
          <Modal
            show={showHistoryPrint}
            onClose={() => setShowHistoryPrint(false)}
            title={`Hall Ticket — ${historyPrintStudent?.hallTicket || ""}`}
            size="xl"
          >
            <div className="d-flex justify-content-end gap-2 mb-3 no-print">
              <button className="btn btn-outline-secondary btn-sm" onClick={() => setShowHistoryPrint(false)}>Close</button>
              <button className="btn btn-primary btn-sm px-4" onClick={() => doPrint(historyPrintRef)}>
                🖨 Print / Download PDF
              </button>
            </div>
            {historyPrintStudent && (
              <div ref={historyPrintRef}>
                <style>{PRINT_STYLES}</style>
                <HallTicket
                  student={historyPrintStudent}
                  examName={examLabel}
                  format={format}
                />
              </div>
            )}
          </Modal>
        </>
      )}
    </div>
  );
};

export default GenerateHallTickets;